import BaseModel from '../../../lib/data/Models/BaseModel'

export default class SupportServiceModel extends BaseModel {
  constructor(rawData = {}, validator = null) {
    super(rawData, validator)
  }

  setData(rawData = {}) {
    super.setData(rawData)

    this.serviceid = parseInt(rawData.serviceid) || 0
    this.name = rawData.name || ''
  }

  boot() {

  }

  /* PROPERTIES */

  /* METHODS */
}
